// React
import React, { Component } from "react";

// Libraries

// Panel
import { PanelHeading, PanelBody } from '../../Components';

// Position
import Position from './Position';

// Stores
import { UserProfileStore, SampleDataStore, CurrencyStore }  from '../../Stores';

// ErrorHandler
import { ErrorHandler } from '../../Utils';

// Styles
import "./dashboard-flex.css";

class Positions extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            positions : {},
            arrowClass : 'icon-arrow-up8 green-text',
            description: ["All of your open margin positions, with detailed, live pricing and profit & loss calculations.",  "Turn off condensed mode to see even more details for each margin position.", "The Pnl colors are as follows: Red -30% and lower, Orange -30% to 0% and Green for profit over 0%."],
            currencySymbols: CurrencyStore.getCurrencySymbols(),
            loading : true,
            message : null,
            condensed : true
        };

        this.refreshPositions = this.refreshPositions.bind(this);
    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

       //console.log('Margins.componentDidMount()');

        // If user logged in, fetch the orders
        if(this.props.user !== null) {
            this.getPositions(false);
        }
        else {
            this.getSamplePositions();
        }
        
    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Retrieves the positions from UserProfileStore
    getPositions(refresh) {

        //console.log('Margins.getPositions()');

        UserProfileStore.getPositions(refresh)
            .then( (positions) => {

                var newPositions = this.flattenPositions(positions);

                var message = null;

                if(Object.keys(newPositions).length === 0) {
                    message = {
                        title : 'No Open Positions',
                        details : "No positions, no stress.  Well what are you waiting for Gekko?!",
                        type : ''
                    }
                }

                this.setState((prev, props) => {
                    return {
                        loading : false,
                        positions : newPositions,
                        message : message
                    }
                });

            }).catch( (error) => {

                const errorMessage = ErrorHandler.parseError('positions', error);

                this.setState((prev, props) => {
                    return {
                        loading : false,
                        message : errorMessage
                    }
                });

            });

    }

    // Retrieves the sample margin data
    getSamplePositions() {

        const positions = this.flattenPositions(SampleDataStore.getMarginData());
        
        this.setState((prev, props) => {
            return {
                loading : false,
                message : null,
                positions : positions
            }
        });

    }


    // Flattens the positions into a single level object
    flattenPositions(exchanges) {

        var positions = {};

        for(let [exchange, details] of Object.entries(exchanges)) {

            if(details.success) {

                if(Object.keys(details.data).length > 0) {

                    for(let [id, position] of Object.entries(details.data)) {

                        position.exchange = exchange;
                        position.symbol = CurrencyStore.getCurrencySymbol(position.quoteCurrency)
    
                        positions[id] = position;
                    }

                }

            }
            
        }

        return positions;

    }


    // Retrieves the latest positions
    refreshPositions = () => {
        
        this.getPositions(true);

        this.setState((prev, props) => {
            return {
                loading : true
            }
        });

    }

    // Toggles the positons being condensed or not
    toggleCondensed = () => {

        this.setState((prevState, prevProps) => {
            return {
                condensed : !prevState.condensed
            }
        });
    }


/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('Margins.render()');

    return (

        <div className="panel panel-flat bg-theme-700">
        
            <PanelHeading title={"Margins"} description={this.state.description} sample={this.props.user === null ? true : false} 
            refresh={this.props.user === null ? null : this.refreshPositions} >

                <div className='button-row check-box'>
                    <label className="checkbox-inline" style={{marginTop:'2px',paddingLeft: '22px'}} onClick={this.toggleCondensed}>
                        <div className="checker"><span style={{color:'#4fc3f7'}}className={this.state.condensed ? 'checked' : ''}><input type="checkbox" className="styled"></input></span></div>
                        condensed
                    </label>
                </div>

            </PanelHeading>

            <PanelBody loading={this.state.loading} message={this.state.message}>

                <div className="row">
                {
                    Object.keys(this.state.positions).map((id) => {
                        return (
                            <Position position={this.state.positions[id]} key={id} socket={this.props.socket} condensed={this.state.condensed}></Position>
                        )
                    })
                }
                </div>

            </PanelBody>
        </div>

    );
  }
}

export default Positions;






// WEBPACK FOOTER //
// ./src/Views/Dashboard/Positions.js